import { IResourceComponentsProps } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";
import Cw8Show from "components/cw8/Cw8Show";

export const PublicationsShow: React.FC<IResourceComponentsProps> = () => {
    // return <AntdInferencer />;

    const resourceName :string = 'publication';
    return (
        <Cw8Show
            resourceName = {resourceName}
        ></Cw8Show>
    );       
};
